
export const initialState = {
    isLoading: false,
    errorMsg: '',
    successMsg: '',
};

export const PatientReducer = (state = initialState, action) => {
    
    switch(action.type){
        case 'profileUpdateSuccess': {
            return {
                ...state,
                successMsg: action.payload,
                errorMsg: '',
            };
        }
        case 'profileUpdateError': {
            return {
                ...state,
                errorMsg: action.payload,
                successMsg:'',
            };
        }
        case 'clearMessage': {
            return {
                ...state,
                errorMsg: '',
                successMsg: '',
            }
        }
        default: 
            return state
    }
}